export const PoolsAccessoriesSection = {
  title: 'Accessoris',
  description:
    `La càmera Rollo Cover de Compass Pools és part integral de la seva piscina i conté un mecanisme submergit amb rodes guia. Quan s'obren o tanquen automàticament, les lames es guien suaument i s'enrotllen al voltant d'un rodet d'acer inoxidable. Les lames estan accionades per un sofisticat motor de rodets instal·lat a la cambra de la coberta. En obrir-se, les lames de la coberta queden invisiblement submergides sota el nivell de l'aigua darrere d'un panell fix del mateix color que la piscina.`,
  compasRolloCover: 'Compass Rollo Cover',
  copingStones: 'Coping stones',
};
